module.exports = __webpack_public_path__ + "af5bc600d8422eb8ae5dc65e67d20778.svg";